const GlobalConfig = {
  apiHostname: 'https://api.jejakgroup.com',
  publicDashboardHostname: 'https://admin.jejakgroup.com',
  publicHostname: 'https://jejakgroup.com',
  assetsHostname: 'https://api.jejakgroup.com/storage',


  // apiHostname: 'http://localhost:8000',
  // publicDashboardHostname: 'http://localhost:3000',
  // publicHostname: 'http://localhost:3000',
  // assetsHostname: 'http://localhost:8000/storage',

  mapAPIKey: 'AIzaSyD1zku1HyO1m5PDoRRcn24zTGWR6TbaIfw',
  tinymceKey: 'jc7ioz7j4lbup161umtl8bumaimfmu6m1uw7iw4w4ghs8pca',
  version: '3.4.4.1',
  defaultTop: 20,
  allowedFormats: {
    image: ['image/jpg', 'image/jpeg', 'image/png'],
  },
  maxFileSize: {
    image: 2500000,
  },
  mobileAppScheme: 'com.jejakgroup.customer',
  mobileAppStoreLink: 'https://play.google.com/store/apps/details?id=com.jejakgroup.customer',
  mobilePlayStoreLink: 'https://play.google.com/store/apps/details?id=com.jejakgroup.customer',
};

export default GlobalConfig;